import React from 'react';
import classes from "./Loader.module.scss";

const Loader = ({className,aa}) => {
  return (
    <div className={aa ? `${classes.aaloader} ${className}`:`${classes.loader} ${className}`} >
    </div>
  );
};

export default Loader;
